'use client'
import { Button } from "@/components/ui/button";
import { ArrowLeft, ShoppingCart } from "lucide-react" // Added ShoppingCart

import { useRouter } from "next/navigation"

import { getTotalItems } from "../config/redux/slices/cartSlice";
import { useSelector } from 'react-redux';
import { useCallback } from 'react';

const COLORS = {
  kWhite: "#FFFFFF",
  inputBorder: "#E0E0E0",
  inputBackground: "#F0F0F0",
  primaryFontColor: "#333333",
  secondaryFontColor: "#666666",
  primaryColor: "#00489b",
  kBlack: "#000000",
}

const SubcategoryHeader = () => {
  const router = useRouter();
  const totalItems = useSelector(getTotalItems);

  // Memoize click handlers for better performance
  const handleBackClick = useCallback(() => {
    router.back();
  }, [router]);

  const handleCartClick = useCallback(() => {
    router.push("/cart");
  }, [router]);

  return (
    <header className="w-full sticky top-0 z-50 bg-white border-b border-[#e3e3e3] flex justify-between items-center">
      <div className="w-full flex items-center justify-between mr-5">
        <Button
          variant="ghost"
          size="lg"
          onClick={handleBackClick}
          className="h-16 w-16"
          aria-label="Go back"
        >
          <ArrowLeft className="h-10 w-10" />
        </Button>

        <button
          className="relative p-2 rounded-lg transition-colors duration-200 hover:bg-gray-100"
          style={{ color: COLORS.primaryColor }}
          onClick={handleCartClick}
          aria-label={`Shopping cart${totalItems > 0 ? ` (${totalItems} items)` : ''}`}
        >
          {/* FIXED: Use Lucide ShoppingCart instead of FontAwesome */}
          <ShoppingCart className="h-6 w-6" />
          {totalItems > 0 && (
            <span
              className="absolute -top-1 -right-1 h-4 w-4 rounded-full text-xs font-bold flex items-center justify-center"
              style={{ background: COLORS.kBlack, color: COLORS.kWhite }}
            >
              {totalItems}
            </span>
          )}
        </button>
      </div>
    </header>
  );
};

export default SubcategoryHeader;
